import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material";
import styles from "./ModalWindwow.module.css";

export default function ModalWindow({ children, visible, setVisible }) {
  const theme = useTheme();

  const rootClasses = [styles.myModal, visible && styles.active]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={rootClasses}
      style={{
        /* předáme barvu z tématu do CSS proměnné */
        "--modal-bg": theme.palette.background.paper,
        "--modal-color": theme.palette.text.primary,
      }}
    >
      <div
        className={styles.myModalContent}
        onClick={(e) => e.stopPropagation()}
      >
        <CloseIcon
          className={styles.closeButton}
          onClick={() => setVisible(false)}
        />
        {children}
      </div>
    </div>
  );
}
